import React from "react";
import { connect } from "react-redux";
import { createAsset } from "actions/asset";
import { closeAssetModal } from "actions/asset_modal";
import { createPicture } from "actions/assetPicture";
import AssetCreateForm from "forms/AssetCreateForm";
import PropTypes from "prop-types";

import Modal, { ModalBody, ModalHeader } from "components/Modal";
import Translate from "utils/translate";

const { t } = new Translate("AssetCreateModal");

const AssetCreateModal = ({ isLoading, onClose, onSave }) => {
  const handleClose = () => {
    if (!isLoading && confirm(t("confirm.cancel"))) onClose(); // eslint-disable-line
  };

  return (
    <Modal onClose={handleClose} isOpen>
      <ModalHeader onClose={handleClose}>{t("title")}</ModalHeader>
      <ModalBody isInfo>{t("description")}</ModalBody>
      <ModalBody>
        <AssetCreateForm onSubmit={onSave} />
      </ModalBody>
    </Modal>
  );
};

AssetCreateModal.propTypes = {
  isLoading: PropTypes.bool,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
};

const mapStateToProps = (state) => ({
  isLoading: state.loading.asset,
  currentUser: state.currentUser,
  currentPortfolio: state.currentPortfolio,
});

const mapDispatchToProps = (dispatch) => ({
  onSave: async (asset) => {
    const res = await dispatch(createAsset(asset));
    if (asset.photo) await dispatch(createPicture(res.value.asset.id, asset.photo));

    dispatch(closeAssetModal());

    return window.location.assign(`/assets/${res.value.asset.id}/infosheet`);
  },

  onClose: () => dispatch(closeAssetModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AssetCreateModal);
